import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, TextLink, P, Alert } from '@manulife/mux';
import { useRealm, useRichIntl, FormattedRichMessage } from 'ciam-self-service-shared';
import { FormattedMessage, useIntl } from 'react-intl';

function ContactPanel(props) {
  const { product } = props;
  const realm = useRealm();
  const richIntl = useRichIntl();
  const intl = useIntl();

  const phone = richIntl.formatMessage({ id: `contact.${realm}.${product}.phone`, defaultMessage: ' ' });
  const email = richIntl.formatMessage({ id: `contact.${realm}.${product}.email`, defaultMessage: ' ' });
  const hours = richIntl.formatMessage(
    {
      id: `contact.${realm}.${product}.hours`,
      defaultMessage: ' ',
    },
    {
      newline: function newline() {
        return '';
      },
    },
  );
  const link = richIntl.formatMessage(
    { id: `contact.${realm}.${product}.link`, defaultMessage: ' ' },
    {
      ContactLink: function ContactLink(chunks) {
        return chunks;
      },
    },
  );
  const message = intl.formatMessage({
    id: `contact.${realm}.${product}.message`,
    defaultMessage: ' ',
  });

  const hasPhone = phone !== ' ';
  const hasEmail = email !== ' ';
  const hasHours = hours !== ' ';
  const hasLink = link !== ' ';
  const hasMessage = message !== ' ';

  return (
    <Accordion
      id={`contact.${realm}.${product}`}
      title={<FormattedRichMessage id={`contact.${realm}.${product}.title`} />}
      customStyle={{ expandablePanelStyle: { marginBottom: '1rem' }, titleStyle: { textAlign: 'left' } }}
    >
      <FormattedRichMessage
        id={`contact.${realm}.${product}.topContent`}
        defaultMessage=" "
        values={{
          MessageCardPrimaryInformation: function MessageCardPrimaryInformation(chunks) {
            return <Alert severity={Alert.SEVERITY.INFO}>{chunks}</Alert>;
          },
          GroupRetirementSupportLink: function GroupRetirementSupportLink(chunks) {
            return (
              <TextLink
                to={richIntl.formatMessage({
                  id: 'contact.customer.groupRetirement.custom.GroupRetirementSupportLink',
                })}
              >
                {chunks}
              </TextLink>
            );
          },
        }}
      />
      {hasPhone && (
        <P id="contact-phone">
          <FormattedRichMessage id="contact.phone" />
          <TextLink to={`tel:${phone}`}>{phone}</TextLink>
          <FormattedMessage id={`contact.${realm}.${product}.phone.extension`} defaultMessage=" " />
        </P>
      )}
      {hasEmail && (
        <P id="contact-email">
          <FormattedRichMessage id="contact.email" />
          <TextLink to={`mailto:${email}`}>{email}</TextLink>
        </P>
      )}
      {hasHours && (
        <P id="contact-hours">
          <FormattedRichMessage id={`contact.${realm}.${product}.hours`} />
        </P>
      )}
      {hasLink && (
        <P>
          <FormattedRichMessage
            id={`contact.${realm}.${product}.link`}
            values={{
              ContactLink: function ContactLink(chunks) {
                return (
                  <TextLink isExternal to={richIntl.formatMessage({ id: `contact.${realm}.${product}.link.url` })}>
                    {chunks}
                  </TextLink>
                );
              },
            }}
          />
        </P>
      )}
      {hasMessage && <P id="contact-message">{message}</P>}
    </Accordion>
  );
}

ContactPanel.propTypes = {
  product: PropTypes.string.isRequired,
};

export default ContactPanel;
